'use client';

import React from 'react';
import { cn } from '@/lib/utils';
import { SkeletonLoader } from '../skeleton-loader';
import { DMImage } from './custom-image';

type PropR2Image = {
  fileName: string;
  className?: string;
  title?: string;
  width?: number;
  height?: number;
};

const R2Image: React.FC<PropR2Image> = ({
  fileName,
  className,
  title,
  width = 450,
  height = 250,
}) => {
  const imageURL = `${process.env.NEXT_PUBLIC_CLOUDFLARE_IMAGE_URL}/${fileName}`;

  return (
    <>
      {fileName ? (
        <DMImage
          src={imageURL}
          className={cn('w-full rounded-md', className)}
          width={width}
          height={height}
          alt={title ?? 'Debug Media Course Thumbnail'}
        />
      ) : (
        <SkeletonLoader height={203} />
      )}
    </>
  );
};

export default R2Image;
